import Component from '../core/Component'
import gsap from 'gsap/all'

export default class Fox extends Component {

  tlBlink = null
  tlEarWiggle = null
  tlTailMovement = null
  tlSniffing = null
  debounce = null

  tlPopcorn = null

  constructor(element) {
    super(element)

    this.ref = {
      glasses: null,
      popcorn: null,
      smallHand: null,

      eyelids: null,
      leftEar: null,
      rightEar: null,

      tail: null,
      nose: null,

      body: null
    }

    window.Fox = this
  }

  prepare() {
    this.setInitialState()
    this.setupBlinking()
    this.setupEarWiggle()
    this.setupTailMovement()
    this.setupSniffing()
    this.setupPopcorn()

    setInterval(() => {
      this.tlEarWiggle.restart()
    }, 7000)
  }

  setInitialState() {
    gsap.to(
      [this.ref.glasses, this.ref.popcorn, this.ref.smallHand],
      { opacity: 0, duration: 0 }
    )
  }

  setupBlinking() {
    this.tlBlink = gsap.timeline({
      repeat: -1,
      repeatDelay: 5
    })

    this.tlBlink.to(this.ref.eyelids, {
      x: 25,
      y: 80,
      duration: .1
    }).to(this.ref.eyelids, {
      x: 0,
      y: 0,
      duration: .2
    })

    this.tlBlink.play()
  }

  setupEarWiggle() {
    this.tlEarWiggle = gsap.timeline({
      repeat: 2,
      paused: true
    })

    this.tlEarWiggle.to(
      this.ref.leftEar,
      {
        rotation: 3,
        duration: .2,
        transformOrigin: 'bottom left'
      }
    ).to(
      this.ref.rightEar,
      {
        rotation: -3,
        duration: .2,
        transformOrigin: 'bottom right',
        delay: -.2
      }
    ).to(
      this.ref.leftEar,
      {
        rotation: 0,
        duration: .2,
        transformOrigin: 'bottom left',
      }
    ).to(
      this.ref.rightEar,
      {
        rotation: 0,
        duration: .2,
        transformOrigin: 'bottom right',
        delay: -.2
      }
    )
  }

  setupTailMovement() {
    this.tlTailMovement = gsap.timeline({
      repeat: -1,
      yoyo: true
    })

    this.tlTailMovement.to(
      this.ref.tail,
      {
        rotation: 20,
        transformOrigin: 'center right',
        duration: 3,
        ease: 'none'
      }
    )
  }

  setupSniffing() {
    this.tlSniffing = gsap.timeline({
      repeat: -1,
      repeatDelay: 4
    })

    this.tlSniffing.to(this.ref.nose, {
      x: -1.5,
      y: -2,
      duration: .2
    }).to(this.ref.nose, {
      x: 0,
      y: 0,
      duration: .2
    }).to(this.ref.nose, {
      x: -1.5,
      y: -2,
      duration: .2
    }).to(this.ref.nose, {
      x: 0,
      y: 0,
      duration: .2
    })
  }

  setupPopcorn() {
    this.tlPopcorn = gsap.timeline({
      paused: true
    })

    this.tlPopcorn.to(this.ref.body, {
      rotation: 50,
      transformOrigin: 'right bottom',
      duration: .2
    })
    .to([this.ref.popcorn, this.ref.glasses, this.ref.smallHand], {
      opacity: 1,
      duration: 0
    })
    .to(this.ref.hand, {
      opacity: 0,
      duration: 0
    })
    .to(this.ref.body, {
      rotation: 0,
      transformOrigin: 'right bottom',
      duration: .2,
      ease: 'back.out'
    })
  }

  getPopcorn() {
    if (this.debounce == null) {
      this.debounce = setTimeout(() => {
        document.querySelector('.Bobble--hero').classList.add('is-active');
        document.querySelector('.confeti').classList.add('is-visible', 'is-running');
        this.tlPopcorn.pause()
        this.tlPopcorn.restart()
      }, 250)
    }
  }

  hidePopcorn() {
    clearTimeout(this.debounce)
    this.debounce = null
    this.tlPopcorn.pause()
    this.tlPopcorn.reverse()
    document.querySelector('.Bobble--hero').classList.remove('is-active');
    document.querySelector('.confeti').classList.remove('is-visible');
    setTimeout(() => {
      document.querySelector('.confeti').classList.remove('is-running');  
    }, 400);
    
  }
}